// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { uniq } from 'lodash';

// Utils
import { createShallowSelector } from '../milanoteReselect/milanoteReselect';

import * as userService from '../../user/userService';

// Selectors
import { getTrackedUserIds } from './remoteUsersSelector';
import { isGuestSelector } from '../../user/currentUserSelector';
import { currentBoardSharedUserIdsSelector } from '../permissions/elementPermissionsSelector';

const mapDispatchToProps = (dispatch) => ({
    fetchUsers: (userIds) => dispatch(userService.fetchUsers(userIds)),
});

/**
 * Fetch any user that is in the user store, or has permissions to the current board (but isn't in the user store).
 *
 * The latter situation could happen if a board with an ACL that contains new users is moved inside another shared
 * board, and the current user then navigates to that board.
 */
const remoteUserSelector = createShallowSelector(
    getTrackedUserIds,
    currentBoardSharedUserIdsSelector,
    (remoteUserIds, currentBoardSharedUserIds) => uniq([...remoteUserIds, ...currentBoardSharedUserIds]),
);

const sharedUserManagerSelector = createSelector(remoteUserSelector, isGuestSelector, (remoteUserIds, isGuest) => ({
    remoteUserIds,
    isGuest,
}));

/**
 * Ensures that the shared users are being fetched whenever the component is mounted or the board is changed.
 */
@connect(sharedUserManagerSelector, mapDispatchToProps)
class RemoteUserManager extends React.Component {
    componentWillMount() {
        const { remoteUserIds, fetchUsers } = this.props;
        fetchUsers(remoteUserIds);
    }

    componentWillReceiveProps(nextProps) {
        // Load remote users
        if (this.props.remoteUserIds !== nextProps.remoteUserIds) {
            const { remoteUserIds, fetchUsers } = nextProps;
            fetchUsers(remoteUserIds);
        }
    }

    render() {
        return null;
    }
}

RemoteUserManager.propTypes = {
    fetchUsers: PropTypes.func,
    remoteUserIds: PropTypes.array,
    isGuest: PropTypes.bool,
};

export default RemoteUserManager;
